import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { usePathParam } from '@chilecompra/react-kit'
import { Skeleton } from '@chilecompra/react-kit/components'
import { onOpenPurchaseOrderDialog, onGetPurchaseOrderDataThunk } from './UniqueSellersSection.actions'
import useReCaptcha from './../../modules/hooks/reCaptcha'
import { USER_TYPE } from '../../config/settings/constant'
import { Box, Link, Toast } from './UniqueSellersSection.styles'

/**
 * The Unique Sellers section container.
 */
const UniqueSellersSection = () => {
  const {
    authInfo: { userType }
  } = useSelector(state => state.authorizationProvider)
  const { executeReCaptcha } = useReCaptcha()
  const { orders, loading, open } = useSelector(state => state.uniqueSeller)
  const dni = usePathParam('rut')
  const filter = { offset: 0, pageSize: 5, field: 'porCode', sort: 'asc' }
  const dispatch = useDispatch()

  useEffect(() => {
    if (!loading || userType === '') return
    if (userType === USER_TYPE.PUBLIC) {
      const execute = async () => {
        const token = await executeReCaptcha({ action: 'provunico' })
        dispatch(onGetPurchaseOrderDataThunk({ dni, filter, token }))
      }

      execute()
    } else {
      dispatch(onGetPurchaseOrderDataThunk({ dni, filter }))
    }
  }, [userType])

  const handleOpen = () => dispatch(onOpenPurchaseOrderDialog())

  return (
    orders.length > 0 && (
      <Box padding="22px 14px 10px">
        {loading && !open && <Skeleton />}
        {(!loading || open) && (
          <Toast severity="info" margin="15px 0 20px 27px" padding="0 12px">
            El proveedor cuenta con órdenes de compra en estado Aceptada y Recepción conforme bajo la causal de trato
            directo "si solo existe un proveedor del bien o servicio".{' '}
            <Link
              color="primary"
              display="inline"
              onClick={handleOpen}
              rel="noreferrer"
              target="_blank"
              textDecoration="underline"
            >
              Ver órdenes de compra relacionadas
            </Link>
          </Toast>
        )}
      </Box>
    )
  )
}

export default UniqueSellersSection
